<script setup>
import { computed } from 'vue'

const props = defineProps({
  tags: {
    type: Array,
    default: () => [],
  },
  statusText: {
    type: String,
    default: '',
  },
  reserveSpace: {
    type: Boolean,
    default: false,
  },
})

const normalizedTags = computed(() =>
  props.tags.map((tag) => String(tag || '').trim()).filter(Boolean)
)
const normalizedStatusText = computed(() => String(props.statusText || '').trim())
const hasContent = computed(
  () => Boolean(normalizedStatusText.value) || normalizedTags.value.length > 0
)

const resolveTagClass = (tag) => ({
  'store-product-image-tags__tag--orange': ['热销', '甄选'].includes(tag),
  'store-product-image-tags__tag--green': ['新品'].includes(tag),
})
</script>

<template>
  <div
    v-if="hasContent || reserveSpace"
    class="store-product-image-tags"
    :class="{ 'store-product-image-tags--empty': !hasContent }"
  >
    <span
      v-if="normalizedStatusText"
      class="store-product-image-tags__tag store-product-image-tags__tag--status"
    >
      {{ normalizedStatusText }}
    </span>
    <span
      v-for="tag in normalizedTags"
      :key="tag"
      class="store-product-image-tags__tag"
      :class="resolveTagClass(tag)"
    >
      {{ tag }}
    </span>
  </div>
</template>

<style scoped lang="scss">
.store-product-image-tags {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-start;
  gap: 4px;
  max-width: 100%;
  min-height: 20px;
  max-height: 20px;
  overflow: hidden;

  &--empty {
    visibility: hidden;
  }

  &__tag {
    @include inline-tag-center;
    flex-shrink: 0;
    width: 36px;
    height: 20px;
    padding: 0 6px;
    border: 0;
    border-radius: 6px;
    background-color: #ffece8;
    color: $primary-color;
    font-size: $font-size-caption;
    line-height: 18px;
    font-weight: 400;
    white-space: nowrap;
  }

  &__tag--orange {
    background-color: #fff7e8;
    color: #ff7d00;
  }

  &__tag--green {
    background-color: $success-bg-color;
    color: $success-color;
  }

  &__tag--status {
    width: auto;
    min-width: 36px;
    background-color: $bg-light-gray;
    color: $text-title-color;
  }
}
</style>
